export type InvalidFieldNavigationRequest = {
  fieldName: string;
  targetTab: number;
  currentTab: number;
  setPendingField: (fieldName: string) => void;
  activateTab: (tabIndex: number) => void;
  navigateWithinCurrentTab: (fieldName: string) => void;
};

export function requestInvalidFieldNavigation(request: InvalidFieldNavigationRequest): void {
  const { fieldName, targetTab, currentTab, setPendingField, activateTab, navigateWithinCurrentTab } = request;

  if (targetTab !== currentTab) {
    setPendingField(fieldName);
    activateTab(targetTab);
    return;
  }

  navigateWithinCurrentTab(fieldName);
}

export type PendingInvalidFieldFlushRequest = {
  pendingField?: string;
  clearPendingField: () => void;
  scheduleAfterRender: (callback: () => void) => void;
  navigateWithinCurrentTab: (fieldName: string) => void;
};

export function flushPendingInvalidFieldNavigation(request: PendingInvalidFieldFlushRequest): void {
  const { pendingField, clearPendingField, scheduleAfterRender, navigateWithinCurrentTab } = request;

  if (!pendingField) {
    return;
  }

  const fieldName = pendingField;
  clearPendingField();
  scheduleAfterRender(() => {
    navigateWithinCurrentTab(fieldName);
  });
}
